import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import PropTypes from 'prop-types';
import Alert from '../../container/Alert';
import Header from '../Header';
//import Header from '../HeaderNoLogout';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'git.instructions.html.header',
    description: 'Page Header Title',
    defaultMessage: 'Git Instructions'
  },
  headerSubTitle: {
    id: 'translation.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation.'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class AssessmentHelp extends Component {
  //const { intl } = props;
  static propTypes = {
    clickSubmitHandler: PropTypes.func.isRequired,
    translation: PropTypes.func.isRequired
  };
  //const fileList = project.files;
  constructor(props) {
    super(props);
    const { intl } = this.props;
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          //subtitle={intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />
        <Alert
          title={this.props.intl.formatMessage(messages.htmlHeader)}
          message={print(this.props.status)}
        />
        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm>
              <div className="form">
                <label
                  style={{
                    width: '100%',
                    fontSize: '14px',
                    textTransform: 'none',
                    lineHeight: '150%',
                    color: '#A9A9A9'
                  }}
                >
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color:'#1f5c71'
                    }}
                  >
                    Git Command Line Tool Instruction
                  </div>
                  <br />
                  <p  style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color:'#797979'
                    }}>
                    If you don’t have a Git command line tool installed on your
                    computer, you can install Git by clicking:{' '}
                    <a  style={{ color:'#1f5c71'}}
                      href="https://docs.gitlab.com/ee/gitlab-basics/start-using-git.html"
                      target="_self"
                    >
                      Start using Git on command line
                    </a>
                    .
                  </p>{' '}
                  <br />
                <p style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color:'#797979'
                    }}>
                    If you have a Git command line tool installed in your
                    computer but you don’t have a repository in SnowPATH’s code
                    repository, you can create your source code repository with
                    a Git command line tool by following:{' '}
                    <a  style={{ color:'#1f5c71'}}
                      href="https://docs.gitlab.com/ee/gitlab-basics/create-project.html"
                      target="_self"
                    >
                      Push to create a new project
                    </a>
                    , {''}or you can use the following commands:
                  </p>{' '}

                  <br />
       <div style={{border:'solid', width:'95%',marginLeft:'12px'}}>        <p style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color:'#797979',
                      marginLeft:'12px'
                    }}>1.	cd into your source code directory {'<source_directory> '}<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}><i>cd {'<source_directory> '}</i></b><br/>
2.	git initialization, and change user name to the real creator’s account<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}> {' '}<i>git init</i></b><br/>
3.	git add files which you want to commit into local Git repository{' '}<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}><i>git add -A</i></b><br/>
4.	check in your source files into local Git repository<br/>
&nbsp;&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}> {' '}<i>git commit -m “Client’s source code”</i></b><br/>
5.	Add remote git original URL represented repository named {'<source_code_repo_name_in_GitLab>'}.{' '}git with user name {'<user_name>'}<br/>

&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}> {' '}<i>git remote add origin https://{'<user_name>'}@snowpath-gitlab.corp.snowflake.com/Assessment/<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'<source_code_repo_name_in_GitLab>.git'}</i></b><br/>

6.	Push into remote git original URL represented repository, type in password for the user named {'<user_name>'} when you are<br/>
&nbsp;&nbsp;&nbsp;&nbsp;prompted to do so<br/>

&nbsp;&nbsp;&nbsp;<b style={{color:'#1f5c71'}}> {' '}<i>git push https://{'<user_name>'}@snowpath-gitlab.corp.snowflake.com/Assessment/{'<source_code_repo_name_in_GitLab>'}.git</i></b>


</p></div>






                <br /><br />
                  <p style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color:'#797979'
                    }}>
                    If you have a Git command line tool installed in your
                    computer and you have a repository in SnowPATH’s code
                    repository but would like to update your source code, you
                    can do so by clicking:{' '}
                    <a style={{ color:'#1f5c71'}}
                      href="https://docs.gitlab.com/ee/gitlab-basics/start-using-git.html"
                      target="_self"
                    >
                      Basic Git commands
                    </a>
                    .
                  </p>
                </label>

                <br />
                <br />
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={() => this.props.clickOKHandler()}
                  >
                    <FormattedMessage
                      id="close.window.button.title"
                      defaultMessage="Close Window"
                    />
                  </button>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(AssessmentHelp);



// WEBPACK FOOTER //
// ./src/components/views/AssessmentHelp/index.js